import { render, staticRenderFns } from "./BookingSingleOverview.vue?vue&type=template&id=61983e30"
import script from "./BookingSingleOverview.vue?vue&type=script&lang=js"
export * from "./BookingSingleOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports